import {
  IAddedExclusions,
  IAddedMultipleExclusions,
  IEditExclusionAction,
  ILoadedCategoriesAction,
  ISetAgencyAction,
  ISetExclusionsAction,
  ISetWicExclusionsErrorAction,
  IWicExclusionAction,
  IWicExclusionState,
} from './types';
import {
  LOAD_CATEGORIES,
  ERROR_DATA_CATEGORIES,
  CATEGORIES_LOADED,
  SET_CURRENT_AGENCY,
  LOAD_EXCLUSIONS,
  EXCLUSIONS_LOADED,
  ERROR_DATA_EXCLUSIONS,
  RESET_EXCLUSIONS,
  RESET,
  EXCLUSIONS_ACTION_ERROR,
  ADDED_EXCLUSION,
  MULTIPLE_EXCLUSIONS_ADDED,
  EXCLUSION_EDITED,
} from './actionTypes';

export const initialState: IWicExclusionState = {
  categoriesAndSubCategories: {},
  syncingCategories: false,
  errorSubCategories: null,
  currentAgency: '',
  exclusions: [],
  syncingExclusions: false,
  errorExclusions: null,
  lastPage: true,
  actionError: null,
};

export const reducer = (
  state: IWicExclusionState = initialState,
  action: IWicExclusionAction
): IWicExclusionState => {
  switch (action.type) {
    case LOAD_CATEGORIES:
      return {
        ...state,
        syncingCategories: true,
        errorSubCategories: null,
      };
    case ERROR_DATA_CATEGORIES:
      return {
        ...state,
        syncingCategories: false,
        errorSubCategories: (action as ISetWicExclusionsErrorAction).payload,
      };
    case CATEGORIES_LOADED:
      return {
        ...state,
        syncingCategories: false,
        errorSubCategories: null,
        categoriesAndSubCategories: {
          ...state.categoriesAndSubCategories,
          [(action as ILoadedCategoriesAction).payload.stateIdentifierCode]: (
            action as ILoadedCategoriesAction
          ).payload.data,
        },
      };
    case SET_CURRENT_AGENCY:
      return {
        ...state,
        currentAgency: (action as ISetAgencyAction).payload,
        lastPage: true,
        exclusions: [],
      };
    case LOAD_EXCLUSIONS:
      return {
        ...state,
        syncingExclusions: true,
        errorExclusions: null,
      };
    case EXCLUSIONS_LOADED:
      return {
        ...state,
        syncingExclusions: false,
        exclusions: (action as ISetExclusionsAction)?.payload?.data,
        lastPage: !!(action as ISetExclusionsAction)?.payload?.lastPage,
      };
    case ERROR_DATA_EXCLUSIONS:
      return {
        ...state,
        syncingExclusions: false,
        errorExclusions: (action as ISetWicExclusionsErrorAction).payload,
      };
    case RESET_EXCLUSIONS:
      return {
        ...state,
        exclusions: [],
      };
    case RESET:
      return initialState;

    case EXCLUSIONS_ACTION_ERROR:
      return {
        ...state,
        actionError: (action as ISetWicExclusionsErrorAction).payload,
      };
    case ADDED_EXCLUSION:
      return {
        ...state,
        actionError: null,
        exclusions: state.exclusions.map((exclusion) =>
          exclusion.upcOrPluCode === (action as IAddedExclusions).payload.productCode
            ? {
                ...exclusion,
                isExcluded: true,
                enterpriseUnit: (action as IAddedExclusions).payload.locations,
              }
            : exclusion
        ),
      };
    case MULTIPLE_EXCLUSIONS_ADDED:
      return {
        ...state,
        actionError: null,
        exclusions: state.exclusions.map((item) =>
          (action as IAddedMultipleExclusions).payload.products.hasOwnProperty(item.upcOrPluCode)
            ? {
                ...item,
                enterpriseUnit: (action as IAddedMultipleExclusions).payload.locations,
                isExcluded: (action as IAddedMultipleExclusions).payload.locations.length > 0,
              }
            : item
        ),
      };
    case EXCLUSION_EDITED:
      return {
        ...state,
        actionError: null,
        exclusions: state.exclusions.map((exclusion) =>
          exclusion.upcOrPluCode === (action as IEditExclusionAction).payload.item
            ? {
                ...exclusion,
                enterpriseUnit: (action as IEditExclusionAction).payload.locations,
                isExcluded: (action as IEditExclusionAction).payload.locations.length > 0,
              }
            : exclusion
        ),
      };
    default:
      return state;
  }
};
